export const PAYROLL_INVOICE_KEYS = {
  all: ['payroll-invoices'] as const,
  lists: () => [...PAYROLL_INVOICE_KEYS.all, 'list'] as const,
  details: () => [...PAYROLL_INVOICE_KEYS.all, 'detail'] as const,
  detail: (id: string) => [...PAYROLL_INVOICE_KEYS.details(), id] as const,
  dashboard: () => [...PAYROLL_INVOICE_KEYS.all, 'dashboard'] as const,
}; 